import { useEffect, useState } from "react";
import { getApi } from "../utils/api.ts"; 
import Cookies from 'js-cookie' ;
import { API_GET_ATTENDANCE_ANALYTICS_DATA } from "../../config/Endpoints.js";

export const useAttendanceAnalytics = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
 const accessToken = Cookies.get("accessToken");

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        setLoading(true);
        const res = await getApi(API_GET_ATTENDANCE_ANALYTICS_DATA, accessToken);
        setData(res.data.data);
      } catch (err) {
        setError(err.message); 
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [accessToken]);

  return { data, loading, error };
};
